<template>
  <div>
    <InputText
      v-model="policyName"
      :data-test-id="$testId('policyName')"
      label="Policy Name"
      name="Policy Name"
      placeholder="Enter Name"
      rules="required"
    />

    <Textarea
      v-model="policyDescription"
      :data-test-id="$testId('policyDescription')"
      label="Description"
      name="Description"
      placeholder="Optional"
    />
  </div>
</template>

<script>
import {
  InputText,
  Textarea,
} from '@jumpcloud/ui-components';

export default {
  name: 'GeneralInfoSectionv2',

  components: {
    Textarea,
    InputText,
  },

  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    policyDescription: {
      get() {
        return this.value.description;
      },
      set(newValue) {
        this.handleValueChange(newValue, 'description');
      },
    },

    policyName: {
      get() {
        return this.value.name;
      },
      set(newValue) {
        this.handleValueChange(newValue, 'name');
      },
    },

  },
  methods: {
    handleValueChange(value, key) {
      this.$emit('input', {
        ...this.value,
        [key]: value,
      });
    },
  },
};
</script>
